export class ColorScheme
{
  static readonly black_transparent = 'rgba(0, 0, 0, 0.5)'
  static readonly black_transparent_80 = 'rgba(0, 0, 0, 0.8)'
  static readonly black_transparent_30    = 'rgba(0, 0, 0, 0.3)'

  static readonly red = '#ff0000';
  static readonly normal_green = '#00ff00';
  static readonly blue = '#0000ff';
  static readonly difficulty_yellow = '#ffff00';
  static readonly cream = '#fffdd0';
  static readonly black = '#000000';
  static readonly white = '#ffffff';
  static readonly white_70 = 'rgba(255, 255, 255, 0.7)';

  static readonly menu_button_outline = "#0BA20E"
  static readonly footer_text_outline = "#27315D"
  static readonly navigation_text_outline = "#1C44AE"
  static readonly league_text = "#BADFFF"
  static readonly tap_zone_bg = 'rgba(0, 0, 0, 0.2)'

  static readonly dialog_title = "#FFF785"
  static readonly dialog_title_outline = "#0C2A53"
  static readonly dialog_continue_outline = "#076D25"
  static readonly dialog_ad_outline = "#2A548A"
  static readonly text_xp_boost = "#FFFA72"

  static readonly dialog_music_item_bg = "#246080"
  static readonly dialog_music_item_bg_active = "#327173"
  static readonly dialog_music_item_circle = "rgba(36, 46, 73, 0.8)"

  static readonly garage_title_bg = "#2788AB"
  static readonly garage_title_outline = "#082858"
  static readonly garage_title_line = "#80D0ED"
  static readonly garage_list_bg = "#19597B"
  
  static readonly garage_card_bg = "#63BDE5"
  static readonly garage_card_outline = "#0E1F46"
  static readonly garage_card_title = "#4DA7CF"
  static readonly garage_card_shadow = "rgba(0, 0, 0, 0.25)"
  static readonly garage_card_button = "#0080C5"
  static readonly garage_card_bg_active = "#FED84C"
  static readonly garage_card_title_active = "#E6AC3F"
  static readonly garage_green = "#10FF40"

  static readonly calendar_dialog_bg = "#916BEE"
  static readonly calendar_item_text_outline = "#285A84"
  static readonly calendar_item_text_outline_current = "#88640F"

  static readonly game_bg_color = "rgba(20, 58, 72, 0.75)"

  static readonly tooltip_title = "#813E04"
  static readonly tooltip_text = "#0C384F"

  static readonly switch_bg_checked = "#1EC123"
  static readonly switch_bg_unchecked = "#CB2B2B"
  static readonly switch_circle = "#FFFEE5"
  static readonly switch_circle_outline = "#E09753"

  static readonly profile_info_text = "#707070";
  static readonly play_dialog_title_outline = "#233F75"
  static readonly play_dialog_title_shadow = "rgba(16, 6, 84, 0.43)"
  static readonly play_dialog_button_outline = "#173B07"
  static readonly play_dialog_text_outline = "#2A5D97"

  static readonly menu_top_el_text = "#003F87"
  
  static readonly game_block_text = "#27098D"

  static readonly shop_block_count = "#003F87"
  static readonly shop_title_text = "#F3FBDC"
  static readonly shop_title_inner_outline = "#641B00"
  static readonly shop_title_outer_outline = "#F0BF1A"
  static readonly shop_title_shadow = "#A95008"
  static readonly shop_tab_text_outline = "#276691"

  // Settings screen (from XD mockup, artboard "Web 1920 – 7")
  static readonly settings_bg = "#173A98"

  static readonly settings_header_top = "#1052FF"
  static readonly settings_header_bottom = "#0A3EC7"
  static readonly settings_header_stripe = "#FDE127"

  static readonly settings_title_bg = "#173A98"
  static readonly settings_title_outline = "#3266D4"

  // Settings dialog (redone from screen -> dialog, new XD spec)
  static readonly settings_dialog_title_outline = "#003F87"
  static readonly settings_support_btn_outline = "#0A4C8C"

  static readonly settings_card_border_top = "#608CFF"
  static readonly settings_card_border_bottom = "#00227D"
  static readonly settings_card_fill_top = "#2658DC"
  static readonly settings_card_fill_bottom = "#1748C9"

  static readonly settings_icon_bg = "#1748C9"

  static readonly settings_toggle_track = "#0432A8"
  static readonly settings_toggle_knob = "#FFFEE5"
  static readonly settings_toggle_on = "#1EC123"
  static readonly settings_toggle_off = "#CB2B2B"

  static readonly settings_support_border = "#51D31C"
  static readonly settings_support_top = "#80D800"
  static readonly settings_support_bottom = "#479800"
  static readonly settings_support_rim_top = "#0189B4"
  static readonly settings_support_rim_mid = "#0BB0C7"
  static readonly settings_support_rim_bottom = "#2AE7FE"

  static readonly settings_link_btn = "#153791"

  // Avatars
  static readonly avatar_stroke           = "#E5A87C"

  // Leaderboard (ported from PicPix)
  static readonly leaderboard_bg                   = "#375090"
  static readonly leaderboard_title                = "#FFF085"
  static readonly leaderboard_title_gradient_from  = "#FFF7AD"
  static readonly leaderboard_title_gradient_to    = "#FFEB69"
  static readonly leaderboard_title_outline        = "#E16727"
  static readonly leaderboard_tab_active_outline   = "#0B5CB5"
  static readonly leaderboard_tab_outline          = "#0B2C8A"
  static readonly leaderboard_content_bg           = "#2A4386"
  static readonly leaderboard_content_bg_substrate = "#365194"
  static readonly leaderboard_avatar_bg            = "#769CE9"
  static readonly leaderboard_tab_text_inactive    = "#B9BFD3"
  static readonly leaderboard_tabs_line            = "#5B78C9"
  static readonly leaderboard_bottom_line          = "#4263BB"
  static readonly leaderboard_tab_border           = "#B04F4F"
  static readonly leaderboard_tab_fill             = "#72023A"
  static readonly leaderboard_separator_line       = "#F5E7B5"
  static readonly leaderboard_content_bg_dark      = "#3E0B1E"
  static readonly leaderboard_bg_gradient_from     = "#870249"
  static readonly leaderboard_bg_gradient_to       = "#B70649"
  static readonly leaderboard_title_text           = "#FAF2A6"
  static readonly leaderboard_title_gradient_btm   = "#B84D43"
  static readonly leaderboard_player_avatar_bg     = "#FEFFE7"
  static readonly leaderboard_score_text           = "#FFFCA7"
  static readonly leaderboard_bg_solid             = "#0e4df1"
  static readonly leaderboard_content_backdrop     = "#052888"
  static readonly leaderboard_screen_background    = "#062E97"

  // GameUI header texts (level, difficulty, shots), tinted to the difficulty's plaque color
  static readonly game_ui_text_outline_common = "#274185"
  static readonly game_ui_text_outline_hard = "#5B1A85"
  static readonly game_ui_text_outline_super_hard = "#8C1222"

  // ContinueOverlay
  static readonly continue_overlay_bonus_text = "#CBFFFA"
  static readonly continue_overlay_caption_outline = "#295D97"
  static readonly continue_overlay_caption_highlight = "#E8124A"

  // BuyFireworksDialog
  static readonly fireworks_dialog_title_outline = "#214DAA"
  static readonly booster_dialog_title_outline = "#103A92"
  static readonly booster_dialog_quantity_outline = "#003F87"

  // MoreLivesDialog
  static readonly more_lives_badge_circle = "#F4E7D4"
  static readonly more_lives_purple_outline = "#5F2172"
  static readonly more_lives_buy_outline = "#196B0E"
  static readonly menu_play_btn_outline_super_hard = "#880615"
  static readonly red_btn_outline = "#880615"
  static readonly blue_btn_outline = "#0A4C8C"
  static readonly non_active_btn_outline = "#5F5F5F"

  // RateGameDialog / GoStoreDialog / UpdateRequiredDialog
  static readonly rate_game_dialog_bg = "#6983DE"
  static readonly rate_game_dialog_content_top = "#8896E6"
  static readonly rate_game_dialog_content_bottom = "#6A84DE"
  static readonly test_button_bg = "#FF5A5F"

  static readonly play_dialog_difficulty_label_outline = "#00346E"

  // Tutorial
  static readonly tutorial_text = "#2F4B87"

  // GameResultOverlay (x2 reward state)
  static readonly result_reward_x2_text = "#FFF88E"

  static readonly adventure_floor_text = "#6E0000"
  static readonly adventure_level_marker_outline = "#00164F"
  static readonly adventure_level_marker_shadow = "#A10000"

  static readonly adventure_widget_text = "#FFE47E"
  static readonly adventure_header_title_outline = "#F8AB17"
  static readonly result_adventure_progress_outline = "#1F4490"
  static readonly result_title_outline_common = "#0B8EFE"
  static readonly result_title_outline_hard = "#A53BFF"
  static readonly result_title_outline_super_hard = "#FF2F6E"
  static readonly result_title_outline_challenge = "#003F87"

  static readonly daily_challenge_title_outline = "#F0BF1A"
  static readonly daily_challenge_title_outline_2 = "#530A01"
  static readonly daily_challenge_title_outline_3 = "#A95008"
  static readonly daily_challenge_day_txt = "#082D58"
  static readonly daily_challenge_content_title = "#FFFA9F"
  static readonly daily_challenge_content_title_outline = "#023765"
  static readonly daily_challenge_level_outline = "#9B0F45"

  static readonly tournament_text_outline = "#002B9A"
  static readonly tournament_capsule_text_outline = "#AA6600"
  static readonly tournament_label_outline = "#E85500"
  static readonly tournament_row_text = "#121D5A"
  static readonly tournament_row_top_rank_outline = "#85804A"
  // Rank outline on the 1st / 2nd / 3rd place stars: each star's darkest rim shade
  static readonly tournament_star_rank_outline_first = "#9E5613"
  static readonly tournament_star_rank_outline_second = "#274DB5"
  static readonly tournament_star_rank_outline_third = "#872B06"
  static readonly tournament_crowns_outline = "#512623"
  static readonly tournament_place_number = "#FFE70F"

  static readonly anchored_tooltip_text = "#2A548A"
  static readonly anchored_tooltip_divider = "#C6AEA3"
}
